import React from 'react'
import Loading from '../../Loading'
import { ReactComponent as CaretDownIcon } from '../../../assets/svg/CaretDownIcon.svg'
import { emotions_heads } from '../../../constants/Constants'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router-dom'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import { ANALYTICS_EVENTS } from '../../../analytics/events'
import useTrackedSurface from '../../../analytics/useTrackedSurface'

function SearchModal({ loading = false, closModal = () => {}, dataLength, loadNext, hasMore, results, total, loadingMore }) {
    const { t } = useTranslation()
    useTrackedSurface(ANALYTICS_EVENTS.ANALYTICS_SEARCH_DIALOG_VIEWED, { content: 'Search for students' })
    return (
        <div className="absolute w-[600px] h-[380px] bg-white z-10 top-[52px] rounded-[16px] shadow-lg p-[12px] flex flex-col">
            <div className="h-[50px] border-b border-b-[#ECEBF8] flex flex-row items-center justify-between">
                <p className={`flex-1 text-[14px] font-semibold text-[#413F5E] ${loading ? 'opacity-0' : 'opacity-100'}`}>
                    {t('We found 5 result(s) based on your search', { total })}
                </p>

                <button className={`flex items-center justify-center rounded-full w-10 h-10  ${'rotate-0 bg-[#ECEBF8]'} transition`} onClick={closModal}>
                    <CaretDownIcon />
                </button>
            </div>
            <div className="flex-1 overflow-y-auto" id="scroll-inf-single-search">
                {loading && (
                    <div className="w-full h-full flex items-center justify-center">
                        <Loading />
                    </div>
                )}
                {!loading && (
                    <div className="py-[8px] flex flex-col gap-[6px]">
                        <InfiniteScroll dataLength={dataLength} next={loadNext} hasMore={hasMore} scrollableTarget="scroll-inf-single-search">
                            {results.map((student) => (
                                <SingleStudent student={student} key={student.id} />
                            ))}
                        </InfiniteScroll>
                        {loadingMore && (
                            <div className="w-full h-[20px] flex items-center justify-center">
                                <Loading size={20} />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

const SingleStudent = ({ student }) => {
    return (
        <Link to={`/analytics/student?id=${student.id}`}>
            <div className="h-[36px] flex flex-row gap-[8px] items-center hover:bg-[#ECEBF8] px-[4px] transition rounded-md">
                <div className="bg-[#F2F2F2] w-[32px] h-[32px] rounded-full flex items-center justify-center">
                    <img src={emotions_heads[student?.feedback ?? 'false']} width={24} height={24} alt="emotion" />
                </div>

                <p className="text-[#413F5E] font-semibold text-[14px]">
                    {student?.first_name} {student?.last_name}
                </p>
                <p className="text-[#413F5E] text-[14px] font-medium">{student?.classesName}</p>
            </div>
        </Link>
    )
}

export default SearchModal
